export default {
    path: '/redirectto',
    meta: {
        title: '',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/redirectto`),
}


// WEBPACK FOOTER //
// ./src/views/RedirectTo/router.js